import { type EnvironmentProviders, isDevMode } from '@angular/core';
import { provideEventTap } from './event-tap';

/**
 * Dev-only observability tap: `console.debug` every dispatched event (its
 * `type` plus payload).
 *
 * Wired once at app startup. Guarded by `isDevMode()`, so it is a no-op in
 * production builds — the initializer subscribes to nothing and never logs.
 * The read-only subscription never dispatches and never `error`/`complete`s the
 * immortal root `Subject`; its teardown is tied to the environment injector's
 * `DestroyRef` (see `provideEventTap`).
 */
export function provideEventBusDevLogger(): EnvironmentProviders {
  return provideEventTap(() =>
    isDevMode()
      ? (event) => console.debug(`[event-bus] ${event.type}`, event)
      : null,
  );
}
